/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "../../../../services/googleAnalyticsService";

const PasswordPageMeta = () => {
  const title = "Passwort setzen | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="robots" content="noindex,nofollow" />
    </Helmet>
  );
};

export default PasswordPageMeta;
